import { Action } from 'types/redux'
import { UpdateJobRequest } from 'utils/atsUtils'
import { Job } from '../jobs/actions'
import * as actions from './actions'

type InitialStateType = {
  storedJob: Partial<Job>
  updatedJob: Partial<Job>
  changedValues?: UpdateJobRequest
}

const initialState: InitialStateType = {
  storedJob: {} as Partial<Job>,
  updatedJob: {} as Partial<Job>,
  changedValues: {} as Partial<UpdateJobRequest>,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.STORE_JOB: {
      return {
        ...state,
        ...action.payload,
      }
    }

    default:
      return state
  }
}
